
import data from "@/mixins/data.js"

export default {
  name: "StepTab2",
  mixins: [data],
}
